import { fromUnits } from "@/composables/money/moneyUtils";
import type { InvoiceItem } from "@/types";

import type { PreviewItem } from "./types";

export const formatItemType = (type: string): string => {
  return type
    .replace(/^(FEE_|EXPENSE_)/, "")
    .replace(/_/g, " ")
    .toLowerCase()
    .replace(/\b\w/g, (c) => c.toUpperCase());
};

/** Adds the euro totals the settle preview prints, converted once from the exact ledger units. */
export const toPreviewItem = (
  item: InvoiceItem
): InvoiceItem & PreviewItem => ({
  ...item,
  total_excl_vat: fromUnits(item.net_units),
  total_with_vat: fromUnits(item.gross_units),
});
